module.exports = __webpack_public_path__ + "static/chip_m-4cec9df60ca78d6d4ab572f294294e78.svg";